<ziro-top-nav></ziro-top-nav>

<div class="ziro-content">
  <nav
    data-automation="base-container-side-nav"
    class="navmenu navmenu-default offcanvas-sm bg-light ziro-admin-menu"
    role="navigation"
  >
    <ul class="nav flex-column">
      @for (link of links(); track link) {
        <li class="nav-item" [attr.data-automation]="link.automation" routerLinkActive="active">
          @if (!link.isHidden) {
            @if (link.isRouterLink && !disableLinks(link)) {
              <a
                class="nav-link"
                [routerLink]="link.url"
                [attr.id]="link.automation"
                [attr.data-automation]="link.automation + '-link'"
              >
                @if (link.icon) {
                  <i class="icon {{ link.icon }}"></i>
                }
                <span>
                  {{ link.label | translate }}
                </span>
                @if (link.isBeta) {
                  <span class="badge bg-warning rounded-pill align-self-center ms-1">
                    {{ 'tkey;reports.call_logs.link.beta.badge' | translate }}
                  </span>
                }
              </a>
            }
            @if (link.isRouterLink && disableLinks(link)) {
              <a
                class="custom-disable"
                [attr.id]="link.automation"
                [attr.data-automation]="link.automation + '-link'"
                [ngbTooltip]="getDisableTooltip(link) | translate"
                [disableTooltip]="!disableLinks(link)"
              >
                <span>
                  {{ link.label | translate }}
                </span>
              </a>
            }
            @if (!link.isRouterLink) {
              <a
                [attr.target]="link.newTab ? '_blank' : '_self'"
                [attr.href]="!disableLinks(link) ? link.url : null"
                [attr.id]="link.automation"
                [attr.data-automation]="link.automation + '-link'"
                [ngbTooltip]="getDisableTooltip() | translate"
                [disableTooltip]="!disableLinks(link)"
                [ngClass]="{
                  'custom-disable': disableLinks(link),
                  'nav-link': !disableLinks(link),
                }"
              >
                <span>
                  {{ link.label | translate }}
                </span>
              </a>
            }
          }
        </li>
      }
    </ul>
  </nav>

  <div class="container-fluid animate__animated animate__fadeIn overflow-hidden px-0">
    @if (pageDisabled()) {
      <div
        class="offset-md-1 col-md-10 ziro-page-alert alert border-warning"
        data-automation="ziro-page-disabled-alert"
      >
        <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning fa-4x"></i>
        <div class="ms-3" [innerHTML]="pageDisabledMessage() | escapeHtml"></div>
      </div>
    }

    @if (!pageDisabled()) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
